import React, { useState, useEffect, useRef } from "react";
import "./slider.css";
import oneSlide from "../../imgs/img-slider-one.jpg";
import twoSlide from "../../imgs/img-slider-two.jpg";
import threeSlide from "../../imgs/img-slider-three.jpg";
import fourSlide from "../../imgs/img-slider-four.jpg";

const slides = [
  {
    image: oneSlide,
    text: "BIENVENIDO A",
    subText: "RADIO RIVADAVIA",
    textbutton: "1",
  },
  {
    image: twoSlide,
    text: "BIENVENIDO A",
    subText: "RADIO RIVADAVIA",
    textbutton: "2",
  },
  {
    image: threeSlide,
    text: "BIENVENIDO A",
    subText: "RADIO RIVADAVIA",
    textbutton: "3",
  },
  {
    image: fourSlide,
    text: "BIENVENIDO A",
    subText: "RADIO RIVADAVIA",
    textbutton: "4",
  },
];

export const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  let [count, setCount] = useState(0);
  const [stop, setStop] = useState(false);

  const nextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === slides.length - 1 ? 0 : prevSlide + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? slides.length - 1 : prevSlide - 1
    );
  };

  useEffect(() => {
    if (count === 5) {
      setCount(0);
      nextSlide();
    } else {
      if (!stop) {
        setTimeout(() => setCount(count + 1), 1000);
      }
    }
  }, [count, stop]);

  return (
    <div
      className="h-screen w-full flex flex-col items-center bg-black"
      id="principal"
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide left-0 w-full h-full opacity-0 absolute transition-opacity duration-100 ease-in-out hidden ${
            index === currentSlide ? "active" : ""
          }`}
          onMouseDown={() => setStop(true)}
          onMouseUp={() => setStop(false)}
        >
          <img
            src={slide.image}
            alt={slide.text}
            className="w-full h-full opacity-50 object-cover"
          />
          <div className="slide-content top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2   absolute text-center flex flex-col justify-center items-center">
            <h1 className="top-text-animation  text-2xl font-bold mb-7 pb-7 text-white relative text-center leading-normal md:text-3xl flex flex-col justify-center items-center">
              {slide.text}{" "}
              <span className="text-orange-400">{slide.subText}</span>
            </h1>

            <p className="slide-description-animation  text-xl mb-4 text-white leading-tight md:text-2xl">
              Es, desde siempre, una radio pionera e innovadora en formatos,
              contenidos y despliegue periodistico.
            </p>
            <a
              href="https://myradioenvivo.ar/radio-mitre"
              target="_blank"
              className="slide-button-animation font-bold text-xl tracking-wider  rounded-3xl duration-100 mt-2 w-56 h-14 text-white border-4 border-orange-400 justify-center items-center flex md:w-64 md:h-16 md:text-2xl"
            >
              Escucha Ahora
            </a>
          </div>
        </div>
      ))}
      <button
        className="responsive-slider left-0  mx-4 absolute top-1/2 -translate-y-1/2  w-8 h-8 md:w-12 md:h-12 md:text-3xl bg-gray-400 border-0 cursor-pointer   text-2xl transition-colors duration-75 ease-in-out rounded-full"
        onClick={prevSlide}
      >
        &#10094;
      </button>
      <button
        className="responsive-slider right-0  mx-4 absolute top-1/2 -translate-y-1/2  w-8 h-8 md:w-12 md:h-12 md:text-3xl bg-gray-400 border-0 cursor-pointer  text-2xl transition-colors duration-75 ease-in-out rounded-full"
        onClick={nextSlide}
      >
        &#10095;
      </button>
    </div>
  );
};
